import * as Constants from "../common/Constants";
import cloneDeep from "lodash/cloneDeep";

const initialState = {
    
    bankCheques: [], 
    isDuplicateChequeNo:false,
    isLoading: false,
    isPosting: false,
    isPosted: false,
    count: 0,
    page: 1,
    pageSize: 10,
    error: null
};

export default function bankChequeReducer(state = initialState, action) {

    var newState;
    switch (action.type) {

        case Constants.REQUEST_ADD_BANK_CHEQUE:        
        case Constants.REQUEST_GET_BANK_CHEQUES:
            newState = { ...state };
            newState.isPosted = false;
            newState.error = null;
            newState.isPosting = true;
            return newState;

        
        case Constants.SUCCESS_ADD_BANK_CHEQUE:  
             
            newState = { ...state };
            newState.bankCheques = [...newState.bankCheques, action.stock],
            newState.isPosting = false;
            newState.error = null;
            newState.isPosted = true;
            return newState;

        case Constants.FAILED_ADD_BANK_CHEQUE:        
        case Constants.FAILED_GET_BANK_CHEQUES:
            newState = { ...state };
            newState.isPosting = false;
            newState.isPosted = false;
            newState.isLoading = false;
            newState.error = action.error;
            return newState;

        case Constants.SUCCESS_GET_BANK_CHEQUES:
            newState = { ...state };
            newState.isPosting = false;
            newState.isPosted = false;
            newState.isLoading = false;
            newState.error = null;
            newState.bankCheques = action.payload;
            return newState;

        case Constants.RESET_BANK_CHEQUE:
            return {
                ...state,
                isLoading: false,
                isPosting: false,
                isPosted: false,
                error: null
            }

        case Constants.REQUEST_CHECK_DUPLICATE_CHEQUE_NUMBER:
            var newState = { ...state };
            newState.isPosting = false;
            newState.isPosted = false;
            newState.error = null;
            newState.isLoading = true;
            return newState;

        case Constants.SUCCESS_CHECK_DUPLICATE_CHEQUE_NUMBER:
            var newState = { ...state };
            newState.isPosting = false;
            newState.isPosted = false;
            newState.error = null;
            newState.isLoading = false;
            newState.isDuplicateChequeNo = action.payload;
            return newState;

        case Constants.FAILED_CHECK_DUPLICATE_CHEQUE_NUMBER:
            var newState = { ...state };
            newState.isPosting = false;
            newState.isPosted = false;
            newState.isLoading = false;
            newState.error = action.error;
            return newState;

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/BankChequeReducer.js